import * as React from 'react';
import { Minus, Plus } from '@sravni/react-icons';
import { useStyles } from '@sravni/react-utils';
import modules_783e1af8 from '../styles/ExpandCell.module.less.js';

const Cell = ({ row }) => {
    const cx = useStyles(modules_783e1af8);
    return (row.getCanExpand() && (React.createElement("div", { "data-qa": "ExpandCell", className: cx('container'), onClick: row.getToggleExpandedHandler() }, row.getIsExpanded() ? React.createElement(Minus, { className: cx('icon') }) : React.createElement(Plus, { className: cx('icon') }))));
};
const ExpandColumn = {
    accessorKey: 'expander',
    header: '',
    size: 48,
    enableResizing: false,
    enableSort: false,
    enableSorting: false,
    enableColumnFilter: false,
    cell: Cell,
};

export { ExpandColumn };
//# sourceMappingURL=ExpandColumn.js.map
